import cebiaLogoFooter from '@/images/cebia-logo-blue.svg'
import drivaliaLogoFooter from '@/images/clients/drivalia-logo.png'
import unicreditLogoFooter from '@/images/clients/unicredit-leasing-logo.svg'
import type { IPartnerSettings } from '.'

const origAppUrl = {
  development: 'https://localhost/Car.Web.Client.CommonClient',
  test: 'https://broker.cebia.cz/test',
  prep: 'https://broker.cebia.cz/prep',
  production: 'https://broker.cebia.cz/prod',
}

const hosts = [
  'broker-new.cebia.cz'
  //, 'localhost:44470'
]

export const CommonClient: IPartnerSettings = {
  partner: 'Cebia',
  origAppUrl: origAppUrl,
  hosts: hosts,
  logo: cebiaLogoFooter
}

export const UniCreditLeasing: IPartnerSettings = {
  partner: 'UniCreditLeasing',
  deployment: 'UniCreditLeasing',
  origAppUrl: origAppUrl,
  hosts: hosts,
  logo: unicreditLogoFooter
}

export const LeasePlan: IPartnerSettings = {
  partner: 'LeasePlan',
  origAppUrl: {
    development: 'https://localhost/Car.Web.Client.CommonClient',
    test: 'https://fip.drivalia.cz/test',
    prep: '',
    production: 'https://fip.drivalia.cz/prod',
  },
  hosts: [
    'fip.drivalia.cz'
    // , 'localhost:44470'
  ],
  logo: drivaliaLogoFooter
}

export const LeasingCS: IPartnerSettings = {
  partner: 'LeasingCS',
  deployment: 'LeasingCS',
  origAppUrl: origAppUrl,
  hosts: hosts,
}